
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.124 12h-.833a.207.207 0 01-.147-.062.211.211 0 01-.061-.149v-.842a.636.636 0 00-.184-.446.622.622 0 00-.441-.185h-1.25a.622.622 0 00-.442.185.636.636 0 00-.183.446v.843c0 .055-.022.109-.061.148a.207.207 0 01-.148.062h-.833a.622.622 0 00-.442.185.636.636 0 00-.183.447v1.263c0 .167.066.328.183.446a.622.622 0 00.442.185h.833a.212.212 0 01.208.21v.843c0 .167.067.328.184.446a.622.622 0 00.442.186h1.25a.622.622 0 00.441-.186.636.636 0 00.184-.446v-.842a.207.207 0 01.208-.21h.833a.622.622 0 00.442-.186.636.636 0 00.183-.446v-1.263a.636.636 0 00-.183-.447.622.622 0 00-.442-.185z","fill":"#0095DA"}}),_c('path',{attrs:{"d":"M22 5.684c0-.446-.176-.875-.488-1.19A1.658 1.658 0 0020.333 4H3.667c-.442 0-.866.177-1.179.493A1.693 1.693 0 002 5.684v12.632c0 .447.176.875.488 1.19.313.317.737.494 1.179.494h16.666c.442 0 .866-.177 1.179-.493.312-.316.488-.745.488-1.191V5.684zM4.083 18.316a.415.415 0 01-.294-.123.423.423 0 01-.122-.298V9.053c0-.112.044-.22.122-.298a.414.414 0 01.294-.123h15.834c.11 0 .216.044.294.123a.423.423 0 01.122.298v8.842a.424.424 0 01-.122.297.415.415 0 01-.294.124H4.083z","fill":"#0095DA"}}),_c('path',{attrs:{"d":"M18.042 11.79h-3.958a.622.622 0 00-.442.184.635.635 0 00.442 1.079h3.958a.622.622 0 00.442-.186.635.635 0 00-.442-1.078zM17 14.316h-2.916a.622.622 0 00-.442.185.635.635 0 000 .893.622.622 0 00.442.185h2.917a.621.621 0 00.442-.185.635.635 0 000-.893.622.622 0 00-.442-.185z","fill":"#0095DA"}})])
          )
        }
      }
    